var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-releases"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.67555 1.89616C7.88368 1.81326 8.11502 1.81326 8.32315 1.89616C8.99408 2.16336 9.12516 3.19227 9.91681 3.24956C10.4743 3.28989 11.0213 2.82516 11.5807 2.96448C11.8063 3.02067 12.0012 3.16451 12.1233 3.36503C12.4975 3.97948 12.0146 4.8826 12.6249 5.39244C13.0488 5.7465 13.7494 5.70068 14.118 6.13472C14.2732 6.31754 14.3495 6.556 14.3295 6.79645C14.2706 7.51175 13.3586 7.95903 13.559 8.72992C13.6977 9.26352 14.2828 9.63862 14.3295 10.2049C14.3495 10.4453 14.2732 10.6838 14.118 10.8666C13.6548 11.4119 12.6532 11.2323 12.3644 11.9714C12.1616 12.4902 12.422 13.1458 12.1233 13.6363C12.0012 13.8368 11.8063 13.9807 11.5807 14.0369C10.8862 14.2098 10.1811 13.4636 9.51275 13.8845C9.03554 14.1849 8.86456 14.8896 8.32315 15.1051C8.11502 15.1881 7.88368 15.1881 7.67555 15.1051C7.13414 14.8896 6.96314 14.1849 6.48594 13.8845C5.82582 13.4689 5.10077 14.2068 4.41796 14.0369C4.19233 13.9807 3.99748 13.8368 3.87538 13.6363C3.50125 13.0218 3.98404 12.1187 3.37382 11.6089C2.94989 11.2548 2.24931 11.3007 1.88071 10.8666C1.72549 10.6838 1.64924 10.4453 1.66912 10.2049C1.71592 9.63862 2.30095 9.26352 2.43968 8.72992C2.63807 7.9671 1.72737 7.50127 1.66912 6.79645C1.64924 6.556 1.72549 6.31754 1.88071 6.13472C2.34385 5.58921 3.34534 5.769 3.63427 5.02987C3.83709 4.51105 3.57674 3.8555 3.87538 3.36503C3.99748 3.16451 4.19233 3.02067 4.41796 2.96448C4.97738 2.82516 5.5244 3.2899 6.08187 3.24956C6.87352 3.19229 7.00462 2.16336 7.67555 1.89616Z",
    fill: "#7750E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 9.38822C6 9.38822 6.58333 9.38822 7.16667 10.4993C7.16667 10.4993 9.0196 7.72155 10.6667 7.16602",
    stroke: "#1F1E25",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.9552a4fa7aca4ab53ec9fa11ff76e3c4.svg";
export { ForwardRef as ReactComponent };